module.exports = __webpack_public_path__ + "img/schools_store.28134532.svg";